import { useData } from './useData';
import { getAllUnarchivedPoems } from '@/services/poemService';
import type { Database } from '@/types/supabase';
import { UseDataResult } from './useData';

// Define Poem type based on DB view
export type PoemDetails = Database['public']['Views']['poem_details']['Row'];

interface UseAllUnarchivedPoemsOptions {
  // Whether to use cache (default true)
  useCache?: boolean;
  // Custom TTL (default 5 minutes)
  cacheTTL?: number;
}

export type UseAllUnarchivedPoemsResult = Omit<UseDataResult<PoemDetails[]>, 'data'> & {
  data: PoemDetails[];
};

export function useAllUnarchivedPoems(options: UseAllUnarchivedPoemsOptions = {}): UseAllUnarchivedPoemsResult {
  const { useCache = true, cacheTTL = 5 * 60 * 1000 } = options;

  const result = useData<PoemDetails[]>({
    fetchFn: getAllUnarchivedPoems,
    cacheKey: useCache ? 'poems:all:unarchived' : undefined,
    cacheTTL,
  });

  return {
    ...result,
    data: (result.data || []) as PoemDetails[],
  };
} 